import { jsx as _jsx } from "react/jsx-runtime";
import { useAgentScope } from '@/features/agent-scope';
import { cn } from '@/shared/lib/cn';
import { AGENT_SCOPE_LABELS, AGENT_SCOPE_UI_MODES, } from '@/shared/model/agent-scope';
import { Button } from '@/shared/ui';
export function AgentScopeToggle({ className }) {
    const { scope, setScope } = useAgentScope();
    if (AGENT_SCOPE_UI_MODES.length <= 1) {
        return null;
    }
    return (_jsx("div", { className: cn('flex flex-wrap gap-2', className), role: "group", "aria-label": "\u041A\u0430\u043A\u0438\u0445 \u0430\u0433\u0435\u043D\u0442\u043E\u0432 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C", children: AGENT_SCOPE_UI_MODES.map((mode) => (_jsx(Button, { type: "button", size: "sm", variant: scope === mode ? 'default' : 'outline', "aria-pressed": scope === mode, onClick: () => setScope(mode), children: AGENT_SCOPE_LABELS[mode] }, mode))) }));
}
